import axiosInstance from "./axiosInstance"

export const getAllProducts = () =>
    axiosInstance.get("/Product/GetAllProducts");